import { SupplyChain, SupplyChainProps } from './SupplyChain'

export default SupplyChain

export { type SupplyChainProps, SupplyChain }
